import { z } from "zod";

export const pauseSettingsSchema = z.object({ pauseResumeMode: z.enum(["MANUAL", "AUTO"]) }).strict();
export type PauseResumeMode = z.infer<typeof pauseSettingsSchema>["pauseResumeMode"];
export const pauseCommandSchema = z.discriminatedUnion("action", [
  z.object({ action: z.literal("begin"), revision: z.number().int().nonnegative() }).strict(),
  z.object({ action: z.literal("duration"), revision: z.number().int().nonnegative(), seconds: z.union([z.literal(60), z.literal(120), z.literal(300), z.null()]) }).strict(),
  z.object({ action: z.literal("resume"), revision: z.number().int().nonnegative() }).strict(),
]);
export type PauseCommand = z.infer<typeof pauseCommandSchema>;
export interface ExercisePauseState {
  runId: string;
  revision: number;
  status: string;
  abortReason?: "INACTIVITY" | "TIMED_NO_ANSWER" | null;
  startedAt: number | null;
  until: number | null;
  chosen: boolean;
  resumeMode: PauseResumeMode;
  pausedMs: number;
  clockStoppedAt?: number | null;
  reflection?: { revision: number; active: boolean; until: number | null };
  serverNow: number;
}
export const PAUSE_PRESENCE_MS = 120_000;
export const PAUSE_IDLE_MS = 15 * 60_000;
